module.exports = __webpack_public_path__ + "static/media/logo.fd65216a.svg";